/**
 * RGB space.
 *
 * @module  color-space/rgb
 */
'use strict'

module.exports = {
	name: 'rgb',
	min: [0,0,0],
	max: [255,255,255],
	channel: ['red', 'green', 'blue'],
	alias: ['RGB']
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/color-space/rgb.js
// module id = ADon
// module chunks = 0